var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alex2-dialog-container"},[_c('div',{staticClass:"alex2-modal"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"button",on:{"click":_vm.onForward}},[_vm._v(_vm._s(_vm.buttonText))])]),_c('img',{staticClass:"img-alex2",attrs:{"src":require("../assets/img/alex-2.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }